import {DomainStore} from 'shared/store';
import {observable, action} from 'mobx';
import {endpoints, types} from 'shared/core';
import {BenefitDivision} from 'stores/benefits';
import _ from 'lodash';

class BenefitDivisionListState {
  store = new DomainStore();

  @observable companyPlans;
  @observable benefitDivisions;

  receiveProps({benefitDivisions}) {
    this.benefitDivisions = benefitDivisions;
  }

  @action async load() {
    if (!_.isEmpty(this.benefitDivisions)) return null;

    await this.store._compose([endpoints.BENEFITS.BENEFIT_DIVISIONS]);
    this.benefitDivisions = this.store._getAll(
      types.BENEFIT_DIVISION, BenefitDivision
    );
  }
}

export default BenefitDivisionListState;
